module.exports = __webpack_public_path__ + "img/wechat.95c17161.svg";